/** @jsxImportSource ./simboluri-jsx */
// DECIZIILE DE PROIECT ale unui element, sub verificările lui: rândurile pe
// care un pas le publică cu verdictul «DECIZIE» (`elemente.eDecizie`) n-au
// E/R, nu trec și nu pică. Printre verificări ar ieși picate (tot ce nu e
// «SE VERIFICA» sau «ATENTIE» e roșu acolo), deci au secțiunea lor.

import { useT } from "../i18n";
import type { DecizieElement } from "./elemente";

export default function DeciziiProiect({ decizii }: { decizii: DecizieElement[] }) {
  const t = useT();
  if (!decizii.length) return null;
  return (
    <div className="ob-card" style={{ overflow: "hidden" }} data-testid="decizii-proiect">
      <div style={{ padding: "11px 14px", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <b>{t("struct.de_hotarat.titlu")}</b>
        <span className="ob-acasa-sub">{t("struct.de_hotarat.sub")}</span>
      </div>
      {decizii.map((d, i) => (
        <div key={i} style={{ padding: "10px 14px", borderTop: "1px solid var(--line)" }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
            <b style={{ fontSize: 13 }}>{d.nume}</b>
            {d.punct && (
              <span className="sg-mono" style={{ fontSize: 11, color: "var(--mut)" }}>
                {d.punct}
              </span>
            )}
          </div>
          {d.nota && <div style={{ fontSize: 12, marginTop: 4 }}>{d.nota}</div>}
          {d.referinta && (
            <div style={{ fontSize: 11, color: "var(--mut)", marginTop: 4 }}>{d.referinta}</div>
          )}
        </div>
      ))}
    </div>
  );
}
